export const WEBHOOK = 'WEBHOOK';
export const WEBHOOK_ALL = `${WEBHOOK}/ALL`;
export const WEBHOOK_BY_ID = `${WEBHOOK}/BY_ID`;
export const WEBHOOK_SEARCH = `${WEBHOOK}/SEARCH`;
